//React Imports
import React from 'react';

//Style Adjustment for padding import
import './style.scss';

//MUI @mui/material imports
import TextField from '@mui/material/TextField';

const TextFieldComponent = ({ helperText, error, chimeContent, setChimeContent, setValueByte, setHelperText, setShowError }) => {
    //Handles Textchange events
    const handleTextChange = (e) => {
        const { target: { value } } = e;
        setChimeContent(value);
    }
    return (
        <div id="chime-field-container">
            <TextField className="chime-content-field" fullWidth multiline={true} id="chime-content"
                variant="standard" color="warning" placeholder="What's really happening?"
                value={chimeContent}
                helperText={helperText} error={error} onChange={handleTextChange}
            />
        </div>

    );
};

export default TextFieldComponent;